// Hook de utilização por bairro — % de pedidos dos últimos 90 dias.
// O backend agrupa por lower(trim(endereco_bairro)); o match com a lista de
// bairros é feito por nome normalizado (normalizarNome).

import { useEffect, useState } from "react";
import { bairrosApi } from "../api/bairrosApi";

export const normalizarNome = (s) => String(s || "").trim().toLowerCase();

export function useBairrosUsage() {
  const [usage, setUsage] = useState({
    total: 0,
    porBairroId: {},
    porBairro: {},
    windowDays: 90,
    carregado: false, // a coluna de uso fica no esqueleto até chegar
  });

  useEffect(() => {
    let ativo = true;
    bairrosApi.getUsage().then(({ data }) => {
      if (!ativo) return;
      setUsage({
        total: data.total_pedidos || 0,
        porBairroId: data.por_bairro_id || {},
        porBairro: data.por_bairro || {},
        windowDays: data.window_days || 90,
        carregado: true,
      });
    });
    return () => {
      ativo = false;
    };
  }, []);

  return usage;
}
